import React from 'react';
import { Box, CircularProgress } from '@nextiva/next-ui-components';

export const LaunchpadLoader = () => {
  return (
    <Box>
      <CircularProgress size={64} />
    </Box>
  );
};
